import React, {createContext, useState} from 'react';
import {  Paper } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { styled } from "@mui/material/styles";
import Container from '@mui/material/Container';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Donation from './forms/Donation';
import MahaShivaratri from './forms/MahaShivaratri';
import PoojaEvent from './forms/PoojaEvent';
import ChykconForm from './forms/ChykconForm';
import JCHYKRetreat from './forms/JCHYKRetreat';
import ElementaryLockin from './forms/ElementaryLockin';
import HighSchoolLockin from './forms/HighSchoolLockin';
import MiddleSchoolLockin from './forms/MiddleSchoolLockin';
import LaborDayRetreat from './forms/LaborDayRetreat';
import AllTXHighSchoolRetreat from './forms/AllTXHighSchoolRetreat';
import BanquetForm from './forms/BanquetForm';
import EndEventForm from './forms/EndEventForm';
import Reports from './forms/Reports';
import BalaviharRegistration from './pages/BalaviharRegistration';
import CulturalRegistration from './forms/CulturalRegistration';
import EventTypesForm from './forms/EventTypesForm';
import RaasGarba from './forms/RaasGarba';
import TshirtInfoForm from './forms/TshirtInfoForm';
import HoliWalkthon from './forms/HoliWalkthon';
import HanumanHavan from './forms/HanumanHavan';
import GitaChanting from './forms/GitaChanting';
import { AuthProvider } from './context/AuthContext';
import { useAuth } from './hooks/useAuth';
import { UserProvider } from './context/UserContext';
import { MemberProfileProvider } from './context/MemberProfileContext';
import SignInForm from './components/Authentication/SignInForm';
import ForgotUsername from './components/Authentication/ForgotUsername';
import ForgotPassword from './components/Authentication/ForgotPassword';
import ChangePassword from './components/Authentication/ChangePassword';
import SameHousehold from './components/Authentication/SameHousehold';
import ValidateOTP from './components/Authentication/ValidateOTP';
import Dashboard from './pages/Dashboard/Dashboard';
import HeaderBar from './components/HeaderBar/HeaderBar';
import FooterBar from './components/FooterBar/FooterBar';
import HouseholdMembers from './components/HouseholdMembers';
import EventTxnsHistory from './components/EventTxnsHistoryComp';
import DonationHistory from './components/DonationHistoryComp';
import BalaviharHistory from './components/BalaviharHistoryComp';
import { TimerProvider } from './context/TimerContext';
import FAQSupport from './components/FAQSupport';
import { useEffect } from 'react';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
const drawerWidth = 250;



const DemoPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    padding: 0,
  },
  ...theme.typography.body2,
  textAlign: 'center',
}));

export const DataContext = createContext();

const allRoutes = (
  <Routes>
    <Route path="/" element={<SignInForm />} />
    <Route path="/Donation" element={<Donation />} />
    <Route path="/MahaShivaratri" element={<MahaShivaratri />} />
    <Route path="/PoojaEvent" element={<PoojaEvent />} />
    <Route path="/AllTXHighSchoolRetreat" element={<AllTXHighSchoolRetreat />} />
    <Route path="/JCHYKRetreat" element={<JCHYKRetreat />} />
    <Route path="/ElementaryLockinForm" element={<ElementaryLockin />} />
    <Route path="/MiddleSchoolLockinForm" element={<MiddleSchoolLockin />} />
    <Route path="/HighSchoolLockinForm" element={<HighSchoolLockin />} />
    <Route path="/LaborDayRetreatold" element={<ChykconForm />} />
    <Route path="/LaborDayRetreat" element={<LaborDayRetreat />} />
    <Route path="/BVRegistration" element={<BalaviharRegistration />} />
    <Route path="/Languages" element={<CulturalRegistration />} />
    <Route path="/HoliWalkthon" element={<HoliWalkthon />} />
    <Route path="/GitaChanting" element={<GitaChanting />} />
    <Route path="/HanumanHavan" element={<HanumanHavan />} />
    <Route path="/Banquet" element={<BanquetForm />} />
    <Route path="/RaasGarba" element={<RaasGarba />} />
    <Route path="/Reports" element={<Reports />} />
    <Route path="/EventTypesForm" element={<EventTypesForm />} />
    <Route path="/dashboard" element={<Dashboard />} />
    <Route path="/ForgotUsername" element={<ForgotUsername />} />
    <Route path="/ForgotPassword" element={<ForgotPassword />} />
    <Route path="/ChangePassword" element={<ChangePassword />} />
    <Route path="/ValidateOTP" element={<ValidateOTP />} />
    <Route path="/HouseholdMembers" element={<HouseholdMembers />} />
    <Route path="/EventTxnsHistoryComp" element={<EventTxnsHistory />} />
    <Route path="/DonationHistoryComp" element={<DonationHistory />} />
    <Route path="/BalaviharHistoryComp" element={<BalaviharHistory />} />
    <Route path="/SameHousehold" element={<SameHousehold />} />
    <Route path="/FAQSupport" element={<FAQSupport />} />
  </Routes>
);

// Must live inside AuthProvider so it can call useAuth()
function AppContent({ drawerOpen, handleDrawerToggle }) {
  const { isLoggedIn } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!isLoggedIn) {
    // Login page: full-width, no Container/DemoPaper, no drawer offset
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <HeaderBar drawerOpen={drawerOpen} handleDrawerToggle={handleDrawerToggle} />
        <Box sx={{ flex: 1, px: { xs: 2, sm: 0 } }}>
          {allRoutes}
        </Box>
        <FooterBar />
      </Box>
    );
  }

  // Logged-in pages: keep original Container/DemoPaper/drawer-offset layout
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Container alignItems="left" component="main" maxWidth="xl" sx={{ flex: 1, mb: 0, px: { xs: 0, sm: 2 } }}>
        <DemoPaper variant="elevation">
          <HeaderBar drawerOpen={drawerOpen} handleDrawerToggle={handleDrawerToggle} />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: { xs: 1, sm: 3 },
              transition: theme.transitions.create(['margin'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
              marginLeft: !isMobile ? `${drawerWidth}px` : 0,
              width: !isMobile ? `calc(100% - ${drawerWidth}px)` : '100%',
            }}
          >
            {allRoutes}
          </Box>
        </DemoPaper>
      </Container>
      <FooterBar />
    </Box>
  );
}

function App() {

  const [events, setEvents] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerToggle = () => setDrawerOpen(prev => !prev);

  return (
    <div className="App">
      <CssBaseline />
      <DataContext.Provider value={{ events, setEvents }}>
        <MemberProfileProvider>
          <UserProvider>
            <AuthProvider>
              <Router>
                <TimerProvider>
                  <AppContent drawerOpen={drawerOpen} handleDrawerToggle={handleDrawerToggle} />
                </TimerProvider>
              </Router>
            </AuthProvider>
          </UserProvider>
        </MemberProfileProvider>
      </DataContext.Provider>
    </div>
  );
}

export default App;
